import { getWindowChrome, getWindowNavigator } from 'core/window/windowService';

export enum OS {
    Windows = 'windows',
    MacOS = 'macos',
    Linux = 'linux',
    IOS = 'ios',
    Android = 'android',
    NA = 'na',
}

export const getUserAgent = (windowNavigator = getWindowNavigator()) => windowNavigator.userAgent;
export const getPlatform = (windowNavigator = getWindowNavigator()) => windowNavigator.platform;

export const isWindows = (): boolean => /windows/i.test(getUserAgent()) || /win/i.test(getPlatform());
export const isMacOS = (): boolean => /mac/i.test(getUserAgent()) || /mac/i.test(getPlatform());
export const isLinux = (): boolean => /linux/i.test(getUserAgent()) || /linux/i.test(getPlatform());
export const isIos = (): boolean => /iphone|ipod|ipad/i.test(getUserAgent()) || /iphone|ipod|ipad/i.test(getPlatform());
export const isAndroid = (): boolean => /android/i.test(getUserAgent()) || /android/i.test(getPlatform());

export const getOS = (): OS => {
    if (isWindows()) {
        return OS.Windows;
    }
    if (isMacOS()) {
        return OS.MacOS;
    }
    if (isLinux()) {
        return OS.Linux;
    }
    if (isIos()) {
        return OS.IOS;
    }
    if (isAndroid()) {
        return OS.Android;
    }
    return OS.NA;
};

const userAgentLowerCase = () => (getUserAgent() || '').toLowerCase();

export const isChrome = () => {
    const uaLowerCase = userAgentLowerCase();
    const chrome = getWindowChrome();
    return !!chrome || uaLowerCase.includes('electron') || uaLowerCase.includes('crios') || uaLowerCase.includes('chrome');
};

export const isSafariBrowser = () => {
    const uaLowerCase = userAgentLowerCase();
    return isIos() && !uaLowerCase.includes('crios') && !uaLowerCase.includes('chrome') && !uaLowerCase.includes('fxios');
};

export const isFireFox = () => {
    return userAgentLowerCase().includes('firefox');
};
